// Tela 2 — Foto sangrada em P&B. Extraído de entrevista-sergio-gargantini.html
// (bloco #s5), refatorado para classe `.tpl-foto-full-bleed`. Ver DOCS/02-foto-full-bleed.md.
import { LOGO_BRANCO_DATA_URI } from '../shared/logo'
import { PLACEHOLDER_IMAGE_DATA_URI } from '../shared/placeholder'
import { cropToImgStyle } from '../shared/crop'
import type { RenderContext, TemplateDefinition } from '../types'

export const CSS = `
  .tpl-foto-full-bleed{padding:0; overflow:hidden;}
  .tpl-foto-full-bleed .ph-wrap{
    position:absolute; inset:0;
  }
  .tpl-foto-full-bleed .ph-wrap img{
    display:block;
  }
  .tpl-foto-full-bleed .logo{position:absolute; top:34px; left:34px; height:24px; z-index:5;}
`

function render(_content: Record<string, unknown>, ctx: RenderContext = {}): string {
  const imgStyle = cropToImgStyle(ctx.imageCrop, 1080 / 1350)
  const src = ctx.imageUrl || PLACEHOLDER_IMAGE_DATA_URI

  return `<section class="slide tpl-foto-full-bleed">
    <div class="ph-wrap reveal-wipe img-reveal">
      <img src="${src}" alt="" style="${imgStyle}">
    </div>
    <div class="logo reveal r3"><img src="${LOGO_BRANCO_DATA_URI}" alt="Lorena"></div>
  </section>`
}

export const fotoFullBleedTemplate: TemplateDefinition = {
  id: 'foto-full-bleed',
  label: 'Foto full bleed',
  tags: ['homem', 'foto'],
  css: CSS,
  fieldsSchema: [
    { key: 'image', label: 'Foto (sangria total)', type: 'image', aspectRatio: 1080 / 1350, help: 'Cobre o card inteiro; use o controle P&B quando quiser remover as cores.' },
  ],
  render,
  previewContent: {},
  previewCtx: { imageUrl: PLACEHOLDER_IMAGE_DATA_URI },
}
